export default __webpack_public_path__ + "static/media/icts-diligencia.1a10ea34.png";